export default __webpack_public_path__ + "static/drummond-77a0d689b8a47a4722adb627467c83cc.jpg";